import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api";
import {BaseBackEND}  from "../../services/auth"

import Card1 from "../../assets/img/banners/card1.png"
import Card2 from "../../assets/img/banners/card2.png"


import Cardenfermangem from "../../assets/img/banners/box_courses/enfermagem.jpg"
import CardenfADM from "../../assets/img/banners/box_courses/adm.jpg"
import CARDGD from "../../assets/img/banners/box_courses/gestaoedesenvolvimento.jpg"

class AllCoursesbyIndex extends Component {

  constructor() {
    super();

    this.state = { 
      categorias: [],
      showcoursebyside:[],
      pos_cursos:[]
      
    }
      
  }


  async componentWillMount() {

    const response1 = await api.post("/categorias", {idunidade:localStorage.getItem('idunidade')});
    this.setState({ 
      categorias: response1.data})


    
    const response2 = await api.post("/categorias/id", {idunidade:localStorage.getItem('idunidade'),idcategoria:this.props.match.params.idcategoria});
    this.setState({ 
    showcoursebyside: response2.data,
    pos_cursos: response2.data.pos_cursos})
      


    }

   

  render() {
    const styletextpos ={
      'font-size':14
    }
    return (
      <React.Fragment>
     <div class="container allcourseindex">
     <h3 class="d-flex justify-content-center">Cursos de Pós-Graduação</h3>

     <div class="catologo-cursod clearfix">
     
     
     <nav class="nav flex-column float-left navcoursespos">
     <a class="btn text-white  flex-column  float-left" ><center>Áreas de Atuação</center></a>
     <a class="nav-link" href={'/pos-graduacao/'}><center>Todos os Cursos</center></a>
     {this.state.categorias.map(el => (
     
      <a class="nav-link" href={'/pos-graduacao/'+el.id}><center>{el.nome}</center></a>

     ))}
    </nav>
        

   


    <div class="container catologo-cursod">



        <div class="row boxshows"> 

       
          <div class="sizetable">
          <h5>{this.state.showcoursebyside.nome}</h5>
            <div class="row imgcursos">
          
            {this.state.pos_cursos.map(elc => (
               elc.isgraduation==0 &&

               elc.status=='1' &&

               
             <div class="col-lg-4">
             <div class="card">


        

                        
                              <div class="card-body">
                              
                                
<center>                
{elc.idcategoria!=16 &&
          <a style={styletextpos} href={'/pos-graduacao/'+elc.longnome+'/'+elc.id+''} class="card-title">{elc.nome}</a>
}
{elc.idcategoria==16 &&
          <a style={styletextpos} href={'/Curso-Curta-Duracao/'+elc.longnome+'/'+elc.id+''} class="card-title">{elc.nome}</a>
}
          </center>                              
                              </div>
                 
                      </div>






              </div>
            ))}
              
             
          
            </div>
          </div>
          















       











        </div>



       



       




        


        


  </div>
  </div>


      





















</div>
        
      </React.Fragment>
       
    );
  }
}

export default withRouter(AllCoursesbyIndex);


// WEBPACK FOOTER //
// ./src/pages/content/allcoursesbycategoria.js